<template>
  <div
    class="modal fade bs-example-modal-center"
    id="helpdesk"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mySmallModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content pl-4">
        <div class="modal-header">
          <h5 class="modal-title mt-0">Help Desk</h5>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
        </div>
        <div class="modal-body">
          <button type="submit" class="btn btn-primary waves-effect waves-light">
            <i class="fas fa-envelope fa-fw"></i>
            <a href="mailto:support@irecharge.com.ng">&nbsp;Mail Us</a>
          </button>
          <h4>Contact Us</h4>
          <p>
            <i class="fas fa-phone fa-fw"></i>
            <a target="_blank" href="tel:+2348149906336">&nbsp;08149906336</a>
          </p>
          <p>
            <i class="fas fa-phone fa-fw"></i>
            <a target="_blank" href="tel:+2348070791433">&nbsp;08070791433</a>
          </p>
          <p>
            <i class="fab fa-whatsapp fa-fw"></i>
            <a
              target="_blank"
              href="https://api.whatsapp.com/send?phone=09030009930"
            >&nbsp;0903 000 9930</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted: function() {
    $("#helpdesk").modal({
      keyboard: false,
      backdrop: "static"
    });
    $("#helpdesk").on("hide.bs.modal", e => {
      this.$router.push("dashboard");
    });
  }
};
</script>
<style scoped>
a {
  color: darkblue;
}
</style>